import type { NotificationGetListInput } from '../../service/types/notification.param'

export type NotificationInfiniteFilter = Pick<
  NotificationGetListInput,
  'isRead' | 'keyword' | 'pageSize'
>

export const notificationQueryKeys = {
  all: ['notifications'] as const,
  infiniteList: (filter: NotificationInfiniteFilter) =>
    [...notificationQueryKeys.all, 'infinite-list', filter] as const,
  totalCount: () => [...notificationQueryKeys.all, 'total-count'] as const,
  unreadCount: () => [...notificationQueryKeys.all, 'unread-count'] as const,
  hasUnread: () => [...notificationQueryKeys.all, 'has-unread'] as const,
}
